module.exports = __webpack_public_path__ + "img/img.e15e4460.png";